export interface WPEvaluationStep {
  // 작업 단계
  // DB Value
  uid: 0,
  evaluationUID: number; // 작업 위험평가서 UID
  workStep: string; // 작업단계
  hazardFactor: string; // 유해위험요인
  solution: string; // 대책
  isFireWork: boolean; // 화기작업허가 여부
  isClosed: boolean; // 밀폐작업허가 여부
  isHeight: boolean; // 고소작업허가 여부
  isStopElectricity: boolean; // 정전작업허가 여부
  isExcavation: boolean; // 굴착작업허가 여부
  isHeavy: boolean; // 중장비작업허가 여부
  isRadiation: boolean; // 방사선작업허가 여부
}

export const initializeEvaluationStep = (): WPEvaluationStep => {
  return {
    uid: 0,
    evaluationUID: 0, // 작업 위험평가서 UID
    workStep: "", // 작업단계
    hazardFactor: "", // 유해위험요인
    solution: "", // 대책
    isFireWork: false, // 화기작업허가 여부
    isClosed: false, // 밀폐작업허가 여부
    isHeight: false, // 고소작업허가 여부
    isStopElectricity: false, // 굴착작업허가 여부
    isExcavation: false, // 굴착작업허가 여부
    isHeavy: false, // 중장비작업허가 여부
    isRadiation: false, // 방사선작업허가 여부
  }
}